<div class="loader-overlay" *ngIf="loaderService.loader$ | async">
    <div class="loader-content">
        <i class="fa-regular fa-dna fa-spin"></i>
        <p class="loading-text">
            Please wait<span class="dots"><span>.</span><span>.</span><span>.</span></span>
        </p>
    </div>
</div>
